// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"__500_content-wrapper__iyqKS","btns-wrapper":"__500_btns-wrapper__l593b"};